import React from "react";

const AppliedCalender = ({ cls }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cls}
    >
      <circle cx="8.40086" cy="15.3149" r="0.745584" fill="currentColor" />
      <circle cx="11.3833" cy="15.3149" r="0.745584" fill="currentColor" />
      <circle cx="14.3647" cy="15.3149" r="0.745584" fill="currentColor" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.7108 5.68416H7.90363V4.90751C7.90363 4.70153 7.8218 4.50399 7.67615 4.35833C7.5305 4.21268 7.33296 4.13086 7.12698 4.13086C6.921 4.13086 6.72346 4.21268 6.57781 4.35833C6.43216 4.50399 6.35033 4.70153 6.35033 4.90751V5.68416H5.57368C4.54416 5.68539 3.55715 6.09492 2.82917 6.8229C2.10119 7.55088 1.69166 8.53789 1.69043 9.56741V18.8872C1.69166 19.9167 2.10119 20.9037 2.82917 21.6317C3.55715 22.3597 4.54416 22.7692 5.57368 22.7705H16.4468C17.4763 22.7692 18.4633 22.3597 19.1913 21.6317C19.9193 20.9037 20.3288 19.9167 20.33 18.8872V10.1418C19.6225 10.4942 18.8246 10.6924 17.9805 10.6924C17.3147 10.6924 16.6776 10.5691 16.091 10.3441H3.24373V9.56741C3.24373 8.94947 3.48921 8.35684 3.92616 7.91989C4.36311 7.48294 4.95574 7.23746 5.57368 7.23746H13.0269C12.8474 6.74948 12.738 6.22765 12.7108 5.68416ZM5.57368 21.2172H16.4468C17.0647 21.2172 17.6574 20.9717 18.0943 20.5347C18.5313 20.0978 18.7767 19.5052 18.7767 18.8872V11.8974H3.24373V18.8872C3.24373 19.5052 3.48921 20.0978 3.92616 20.5347C4.36311 20.9717 4.95574 21.2172 5.57368 21.2172Z"
        fill="currentColor"
      />
      <path
        d="M21.6591 5.57547C21.6591 7.61616 20.0048 9.27047 17.9641 9.27047C15.9234 9.27047 14.2691 7.61616 14.2691 5.57547C14.2691 3.53478 15.9234 1.88047 17.9641 1.88047C20.0048 1.88047 21.6591 3.53478 21.6591 5.57547Z"
        stroke="currentColor"
        strokeWidth="1.3"
      />
      <path
        d="M16.6309 5.72059L17.2629 6.35259C17.34 6.42976 17.4648 6.43081 17.5433 6.35497L19.2976 4.65918"
        stroke="currentColor"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default AppliedCalender;
